import styled from 'styled-components';

export const AppContainer = styled.div`
  background: #0a192f;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  overflow: hidden;
`;